// test1344
(1344 && 0);
